export default __webpack_public_path__ + "images/filtering-icons.269ceb0608f163becf62a6271bcf40ea.svg";